var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNewsletterinline = function SvgNewsletterinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    fill: "#0073E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.125 7.5h-8.25c-.365 0-.714.139-.972.386a1.3 1.3 0 0 0-.403.931v.264l5.5 2.964 5.5-2.898v-.33c0-.349-.145-.684-.403-.931a1.4 1.4 0 0 0-.972-.386"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.656 13.142 6.5 10.375v4.808c0 .35.145.685.403.932s.607.386.972.386h8.25c.365 0 .714-.139.972-.386a1.3 1.3 0 0 0 .403-.932v-4.808l-5.156 2.767a.89.89 0 0 1-.688 0"
  })));
};
export default SvgNewsletterinline;